<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle cx="8" cy="8" r="6.5" />
    <path d="M5 5h6" />
    <path d="M8 5v6" />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [Number, String],
    default: 16,
  },
})
</script>
